
  export const CUSTOMERNOTIFICATIONTYPES_RECEIVED = "CUSTOMERNOTIFICATIONTYPES_RECEIVED";
  export const SET_CUSTOMERNOTIFICATIONTYPE = "SET_CUSTOMERNOTIFICATIONTYPE";
  export const CREATE_CUSTOMERNOTIFICATIONTYPE = "CREATE_CUSTOMERNOTIFICATIONTYPE";
  export const SET_PROPERTY_CUSTOMERNOTIFICATIONTYPE = "SET_PROPERTY_CUSTOMERNOTIFICATIONTYPE";
  